import React, { useMemo, useState, useEffect, useContext } from "react";
import { useLocation, useParams } from "react-router-dom";

import KpiSection from "./KpiSection";
import { FilterSection } from "./FilterSection";
import TrendSection from "./TrendSection";
import GeographySection from "./GeographySection";
import InsightsSection from "./InsightsSection";
import SummaryTableSection from "./SummaryTableSection";
import { classNames, isBetween } from "../../../utils/helpers";
import { BASE_URL } from "../../../config/api";
import { AuthContext } from "../../../context/AuthContext";
import axios from "axios";

/** ---------- page ---------- */
export default function CompanySales({
  fromUserView = false,
  selectedUserId = null,
  selectedUserRole = null,
  selectedUserCompanyId = null,
  balanceAmount,
  setBalanceAmount,
  walletLoading,
  handlePayment,
  fetchWalletBalance,
  walletRefresh,
  setWalletLoading,
  walletPermissionLoading,
  shouldShowWallet
}) {

  const { id } = useParams();
  const location = useLocation();
  const [trend, setTrend] = useState([]);
  const [trendLoading, setTrendLoading] = useState(false);
  const [productPie, setProductPie] = useState([]);
  const [topProduct, setTopProduct] = useState(null);
  const [lowProduct, setLowProduct] = useState(null);
  const [productPieLoading, setProductPieLoading] = useState(false);
  // const [balanceAmount, setBalanceAmount] = useState(0);

  const [geoBars, setGeoBars] = useState([]);
  const [geoTiles, setGeoTiles] = useState([]);
  const [geoTop, setGeoTop] = useState(null);
  const [geoLoading, setGeoLoading] = useState(false);
  const [mode, setMode] = useState("state");
  const [kpiLoading, setKpiLoading] = useState(false);

  const [activeTab, setActiveTab] = useState("trend");
  const [startDate, setStartDate] = useState(null);
const [endDate, setEndDate] = useState(null);

  const [payoutSummary, setPayoutSummary] = useState({
  total_sales: 0,
  pending_invoices: { count: 0, amount: 0 },
  credit_notes: 0,
  warranty_submitted: 0,
  payable_amount: 0,
  paid_amount: 0,
  my_earnings: 0,
  
});

const authUser = JSON.parse(localStorage.getItem("authUserData"));
const sessionId = authUser?.id;
const sessionRole = Number(authUser?.role);

const { user } = useContext(AuthContext);

const [isMobile, setIsMobile] = useState(window.innerWidth < 640);

useEffect(() => {
  const handleResize = () => {
    setIsMobile(window.innerWidth < 640);
  };

  window.addEventListener("resize", handleResize);
  return () => window.removeEventListener("resize", handleResize);
}, []);

const isRetailerMobile =
  (Number(user?.role) === 5 || Number(user?.role) === 6) && isMobile;


const effectiveRole = fromUserView
  ? Number(selectedUserRole)
  : sessionRole;
console.log("effectiveRole: ", effectiveRole)

  const getRoleBasedParams = () => {
  const targetId = fromUserView ? selectedUserId : sessionId;

  if (!targetId || !effectiveRole) {
    console.warn("❌ Missing role or targetId", { effectiveRole, targetId });
    return null;
  }

  if (effectiveRole === 2) return { company_id: targetId };
  if (effectiveRole === 4) return { agent_id: targetId };
  if (effectiveRole === 5) return { retailer_id: targetId };
  if (effectiveRole === 6) return { promoter_id: targetId };

  console.warn("❌ Unsupported role:", effectiveRole);
  return null;
};

const buildQuery = (params) =>
  new URLSearchParams(params).toString();

  useEffect(() => {

    const fetchPayoutSummary = async () => {

      try {

        setKpiLoading(
          true
        );

        // ✅ START LOADER

        const params =
          getRoleBasedParams();

        if (
          !params
        ) return;

        const response =
          await axios.get(
            `${BASE_URL}warranty/payout-summary`,
            {
              params,

              headers: {
                Accept:
                  "application/json",

                "Content-Type":
                  "application/json",
              },
            }
          );

        const json =
          response.data;

        if (
          !json?.status
        ) {

          throw new Error(
            "Failed to fetch payout summary"
          );
        }

        setPayoutSummary(
          {

            total_sales:
              json.data
                ?.total_sales ??
              0,

            pending_invoices:
              {
                count:
                  json.data
                    ?.pending_invoices
                    ?.count ??
                  0,

                amount:
                  json.data
                    ?.pending_invoices
                    ?.amount ??
                  0,
              },

            credit_notes:
              json.data
                ?.credit_notes ??
              0,

            warranty_submitted:
              json.data
                ?.warranty_submitted ??
              0,

            payable_amount:
              json.data
                ?.payable_amount ??
              0,

            paid_amount:
              json.data
                ?.paid_amount ??
              0,

            my_earnings:
              json.data
                ?.my_earnings ??
              0,

            total_invoice_count:
              json.data
                ?.total_invoice_count ??
              0,
          }
        );

      } catch (err) {

        console.error(
          "Payout summary error",
          err
        );

      } finally {

        setKpiLoading(
          false
        );

        // ✅ STOP LOADER
      }
    };

    fetchPayoutSummary();

  }, [
    effectiveRole,
    sessionId,
    selectedUserId,
    fromUserView,
  ]);

  const fetchWalletFromZoho = async () => {

    try {

      setWalletLoading?.(
        true
      );

      const authUser =
        JSON.parse(
          localStorage.getItem(
            "authUserData"
          ) || "{}"
        );

      const role =
        Number(
          authUser?.role
        );

      let company_id;

      let user_id;

      if (
        fromUserView &&
        selectedUserId
      ) {

        company_id =
          authUser?.id;

        user_id =
          selectedUserId;

      } else {

        company_id =
          authUser?.company_id;

        // ✅ ROLE BASED LOGIC
        if (
          role === 6
        ) {

          user_id =
            authUser?.created_by_id ||
            authUser?.id;

          // fallback safety

        } else {

          user_id =
            authUser?.id;
        }
      }

      const response =
        await axios.get(
          `${BASE_URL}company/sync-wallet-from-zoho`,
          {
            params: {
              company_id,
              user_id,
            },

            headers: {
              Accept:
                "application/json",

              "Content-Type":
                "application/json",
            },
          }
        );

      const data =
        response.data;

      if (
        data?.status
      ) {

        setBalanceAmount?.(
          Number(
            data.wallet_balance
          )
        );
      }

    } catch (err) {

      console.error(
        "Wallet sync failed:",
        err
      );

    } finally {

      setWalletLoading?.(
        false
      );

    }
  };

useEffect(() => {
  fetchWalletFromZoho();
}, [fromUserView, selectedUserId, walletRefresh]);


  useEffect(() => {

    const fetchProductRevenueShare = async () => {

      try {

        setProductPieLoading(
          true
        );

        const authUser =
          JSON.parse(
            localStorage.getItem(
              "authUserData"
            )
          );

        const retailerId =
          authUser?.id;

        if (
          !retailerId
        ) return;

        const response =
          await axios.get(
            `${BASE_URL}warranty/charts/product-revenue-share`,
            {
              params:
                getRoleBasedParams(),

              headers: {
                Accept:
                  "application/json",

                "Content-Type":
                  "application/json",
              },
            }
          );

        const json =
          response.data;

        if (
          !json?.status
        ) {

          throw new Error(
            "Failed to fetch product revenue share"
          );
        }

        /* ---- Transform API → Recharts Pie format ---- */
        setProductPie(
          (
            json.data || []
          ).map((p) => ({
            name:
              p.product_type,

            value:
              p.revenue,
          }))
        );

        setTopProduct(
          json.top_product
            ? {
                name:
                  json.top_product
                    .product_type,

                revenue:
                  json.top_product
                    .revenue,
              }
            : null
        );

        setLowProduct(
          json.low_product
            ? {
                name:
                  json.low_product
                    .product_type,

                revenue:
                  json.low_product
                    .revenue,
              }
            : null
        );

      } catch (err) {

        console.error(
          "Product revenue share error:",
          err
        );

        setProductPie(
          []
        );

        setTopProduct(
          null
        );

        setLowProduct(
          null
        );

      } finally {

        setProductPieLoading(
          false
        );

      }
    };

    fetchProductRevenueShare();

  }, []);


  useEffect(() => {

    const fetchGeographyRevenue = async () => {

      try {

        setGeoLoading(
          true
        );

        const authUser =
          JSON.parse(
            localStorage.getItem(
              "authUserData"
            )
          );

        const retailerId =
          authUser?.id;

        if (
          !retailerId
        ) return;

        const response =
          await axios.get(
            `${BASE_URL}warranty/charts/geography-revenue`,
            {
              params: {
                ...getRoleBasedParams(),
                type: mode,
              },

              headers: {
                Accept:
                  "application/json",

                "Content-Type":
                  "application/json",
              },
            }
          );

        const json =
          response.data;

        if (
          !json?.status
        ) {

          throw new Error(
            "Failed to fetch geography revenue"
          );
        }

        /* ---- Bar chart data ---- */
        setGeoBars(
          json.chart.labels.map(
            (
              label,
              idx
            ) => ({
              name:
                label,

              revenue:
                json.chart
                  .values[
                  idx
                ],
            })
          )
        );

        /* ---- Heat tiles ---- */
        setGeoTiles(
          json.tiles || []
        );

        /* ---- Top label ---- */
        setGeoTop(
          json.top || null
        );

      } catch (err) {

        console.error(
          "Geography revenue error:",
          err
        );

        setGeoBars(
          []
        );

        setGeoTiles(
          []
        );

        setGeoTop(
          null
        );

      } finally {

        setGeoLoading(
          false
        );

      }
    };

    fetchGeographyRevenue();

  }, [mode]);

  // company name header (same pattern as your invoices)
  const companyObj = location.state?.c || location.state?.company || null;
  const companyName =
    companyObj?.business_name || companyObj?.name || location.state?.companyName || "Company";

  /** Mock transactions data (replace with API) */
  const raw = useMemo(
    () => [
      // date, state, district, product, amount, units, customerCode, customerName, creditNote, claimCount
      { date: "2025-10-01", state: "MAHARASHTRA", district: "RAIGAD", product: "iPhone 13", amount: 320000, units: 8, customerCode: "CUST-001", customerName: "A Retail", creditNote: 8000, claimCount: 3 },
      { date: "2025-10-02", state: "MAHARASHTRA", district: "THANE", product: "Samsung S22", amount: 210000, units: 7, customerCode: "CUST-002", customerName: "B Store", creditNote: 0, claimCount: 1 },
      { date: "2025-10-05", state: "GUJARAT", district: "VALSAD", product: "iPhone 13", amount: 180000, units: 5, customerCode: "CUST-003", customerName: "C Mobile", creditNote: 6000, claimCount: 2 },
      { date: "2025-10-08", state: "GUJARAT", district: "SURAT", product: "OnePlus 11", amount: 145000, units: 5, customerCode: "CUST-004", customerName: "D Hub", creditNote: 2000, claimCount: 1 },
      { date: "2025-10-11", state: "KARNATAKA", district: "BENGALURU", product: "Samsung S22", amount: 260000, units: 9, customerCode: "CUST-001", customerName: "A Retail", creditNote: 5000, claimCount: 4 },
      { date: "2025-10-14", state: "KARNATAKA", district: "MYSURU", product: "Vivo V29", amount: 95000, units: 5, customerCode: "CUST-005", customerName: "E Phones", creditNote: 0, claimCount: 1 },
      { date: "2025-10-19", state: "MAHARASHTRA", district: "RAIGAD", product: "OnePlus 11", amount: 120000, units: 4, customerCode: "CUST-006", customerName: "F Corner", creditNote: 0, claimCount: 0 },
      { date: "2025-10-22", state: "GUJARAT", district: "SURAT", product: "Vivo V29", amount: 80000, units: 4, customerCode: "CUST-002", customerName: "B Store", creditNote: 3000, claimCount: 2 },
      { date: "2025-10-25", state: "MAHARASHTRA", district: "THANE", product: "iPhone 13", amount: 240000, units: 6, customerCode: "CUST-007", customerName: "G Mart", creditNote: 9000, claimCount: 2 },
      { date: "2025-10-29", state: "KARNATAKA", district: "BENGALURU", product: "iPhone 13", amount: 200000, units: 5, customerCode: "CUST-008", customerName: "H Shop", creditNote: 0, claimCount: 1 },
    ],
    []
  );

  /** Filters */
  // state | district
  const [q, setQ] = useState("");
  const [state, setState] = useState("ALL");
  const [district, setDistrict] = useState("ALL");
  const [product, setProduct] = useState("ALL");
  const [from, setFrom] = useState("");
  const [to, setTo] = useState("");

  // reset district when state changes
  useEffect(() => setDistrict("ALL"), [state]);

  const states = useMemo(() => ["ALL", ...Array.from(new Set(raw.map(r => r.state))).sort()], [raw]);
  const districts = useMemo(() => {
    const list = raw
      .filter(r => state === "ALL" ? true : r.state === state)
      .map(r => r.district);
    return ["ALL", ...Array.from(new Set(list)).sort()];
  }, [raw, state]);
  const products = useMemo(() => ["ALL", ...Array.from(new Set(raw.map(r => r.product))).sort()], [raw]);

  const filtered = useMemo(() => {
    const s = q.trim().toLowerCase();
    return raw.filter(r => {
      if (!isBetween(r.date, from, to)) return false;
      if (state !== "ALL" && r.state !== state) return false;
      if (district !== "ALL" && r.district !== district) return false;
      if (product !== "ALL" && r.product !== product) return false;

      if (s) {
        const hay = [r.state, r.district, r.product, r.customerCode, r.customerName, r.date]
          .filter(Boolean).join(" ").toLowerCase();
        if (!hay.includes(s)) return false;
      }
      return true;
    });
  }, [raw, q, state, district, product, from, to]);

  /** KPIs */
  const kpis = useMemo(() => {
  const revenue = payoutSummary.total_sales ?? 0;
  const creditNotes = payoutSummary.credit_notes ?? 0;

  return {
    revenue,
    units: payoutSummary.pending_invoices?.count ?? 0,
    units1: payoutSummary.total_invoice_count ?? 0,
    uninvoicedAmount:payoutSummary.pending_invoices?.amount ?? 0,
    creditNotes,
    creditRatio: revenue > 0 ? creditNotes / revenue : 0,
    claims: payoutSummary.warranty_submitted ?? 0,
    payableAmount: payoutSummary.payable_amount ?? 0,
    paidAmount: payoutSummary.paid_amount ?? 0,
    myEarnings: payoutSummary.my_earnings ?? 0,
  };
}, [payoutSummary]);


  /** Aggregate: state & district */
  // const byState = useMemo(() => {
  //   const map = new Map();
  //   filtered.forEach(r => {
  //     const k = r.state;
  //     const prev = map.get(k) || { name: k, revenue: 0, units: 0, creditNotes: 0, claims: 0 };
  //     prev.revenue += r.amount;
  //     prev.units += r.units;
  //     prev.creditNotes += r.creditNote;
  //     prev.claims += r.claimCount;
  //     map.set(k, prev);
  //   });
  //   return Array.from(map.values()).sort((a,b) => b.revenue - a.revenue);
  // }, [filtered]);

  // const byDistrict = useMemo(() => {
  //   const map = new Map();
  //   filtered.forEach(r => {
  //     const k = `${r.state} • ${r.district}`;
  //     const prev = map.get(k) || { name: r.district, state: r.state, key: k, revenue: 0, units: 0, creditNotes: 0, claims: 0 };
  //     prev.revenue += r.amount;
  //     prev.units += r.units;
  //     prev.creditNotes += r.creditNote;
  //     prev.claims += r.claimCount;
  //     map.set(k, prev);
  //   });
  //   return Array.from(map.values()).sort((a,b) => b.revenue - a.revenue);
  // }, [filtered]);

  /** Product comparison (overall + within selected state/district already via filtered) */
  const byProduct = useMemo(() => {
    const map = new Map();
    filtered.forEach(r => {
      const k = r.product;
      const prev = map.get(k) || { name: k, revenue: 0, units: 0 };
      prev.revenue += r.amount;
      prev.units += r.units;
      map.set(k, prev);
    });
    return Array.from(map.values()).sort((a,b) => b.revenue - a.revenue);
  }, [filtered]);

  // const topProduct = byProduct[0];
  // const lowProduct = byProduct[byProduct.length - 1];

  /** Who mostly sale/claim */
  const byCustomer = useMemo(() => {
    const map = new Map();
    filtered.forEach(r => {
      const k = r.customerCode || r.customerName;
      const prev = map.get(k) || { code: r.customerCode || "—", name: r.customerName || "—", revenue: 0, claims: 0, creditNotes: 0 };
      prev.revenue += r.amount;
      prev.claims += r.claimCount;
      prev.creditNotes += r.creditNote;
      map.set(k, prev);
    });
    return Array.from(map.values()).sort((a,b) => b.revenue - a.revenue);
  }, [filtered]);

  const mostClaims = useMemo(() => [...byCustomer].sort((a,b) => b.claims - a.claims).slice(0,5), [byCustomer]);
  const mostCreditNotes = useMemo(() => [...byCustomer].sort((a,b) => b.creditNotes - a.creditNotes).slice(0,5), [byCustomer]);

  /** Trend line (revenue by date) */
  // const trend = useMemo(() => {
  //   const map = new Map();
  //   filtered.forEach(r => {
  //     const k = r.date;
  //     map.set(k, (map.get(k) || 0) + r.amount);
  //   });
  //   return Array.from(map.entries())
  //     .sort((a,b) => a[0].localeCompare(b[0]))
  //     .map(([date, revenue]) => ({ date, revenue }));
  // }, [filtered]);

  /** “Map tiles” data */
  // const mapData = mode === "state" ? byState : byDistrict.map(d => ({ name: d.key, revenue: d.revenue }));
  // const maxMapValue = useMemo(() => mapData.reduce((m, x) => Math.max(m, x.revenue || 0), 0), [mapData]);
  const maxMapValue = useMemo(
  () => geoTiles.reduce((m, x) => Math.max(m, x.revenue || 0), 0),
  [geoTiles]
);


  /** Chart data (top N for readability) */
  // const topStates = byState.slice(0, 8);
  // const topDistricts = byDistrict.slice(0, 10);
  const topProducts = byProduct.slice(0, 8);

  /** Pie: revenue share by product (top 5 + others) */
  // const productPie = useMemo(() => {
  //   const top = byProduct.slice(0, 5);
  //   const rest = byProduct.slice(5).reduce((a, p) => a + p.revenue, 0);
  //   const arr = top.map(p => ({ name: p.name, value: p.revenue }));
  //   if (rest > 0) arr.push({ name: "Others", value: rest });
  //   return arr;
  // }, [byProduct]);


//   useEffect(() => {
//   const fetchRevenueTrend = async () => {
//     try {
//       setTrendLoading(true);

//       const authUser = JSON.parse(localStorage.getItem("authUserData"));
//       const retailerId = authUser?.id;
//       if (!retailerId) return;

//       const res = await fetch(
//         `${BASE_URL}warranty/charts/revenue-trend?${buildQuery(getRoleBasedParams())}`
//       );

//       const json = await res.json();

//       if (!res.ok || !json.status) {
//         throw new Error("Failed to fetch revenue trend");
//       }

//       // API already matches recharts format
//       setTrend(json.data || []);
//     } catch (err) {
//       console.error("Revenue trend error:", err);
//       setTrend([]);
//     } finally {
//       setTrendLoading(false);
//     }
//   };

//   fetchRevenueTrend();
// }, []);

  useEffect(() => {

    const fetchRevenueTrend = async () => {

      try {

        setTrendLoading(
          true
        );

        const params = {
          ...getRoleBasedParams(),
        };

        if (
          startDate &&
          endDate
        ) {

          params.from_date =
            startDate
              .toISOString()
              .split("T")[0];

          params.to_date =
            endDate
              .toISOString()
              .split("T")[0];
        }

        const response =
          await axios.get(
            `${BASE_URL}warranty/charts/revenue-trend`,
            {
              params,

              headers: {
                Accept:
                  "application/json",

                "Content-Type":
                  "application/json",
              },
            }
          );

        const json =
          response.data;

        if (
          !json?.status
        ) {

          throw new Error(
            "Failed to fetch revenue trend"
          );
        }

        setTrend(
          json.data || []
        );

      } catch (err) {

        console.error(
          "Revenue trend error:",
          err
        );

        setTrend(
          []
        );

      } finally {

        setTrendLoading(
          false
        );

      }
    };

    fetchRevenueTrend();

    // ✅ always call

  }, [
    startDate,
    endDate,
    effectiveRole,
    sessionId,
  ]);


const hasData = (arr) => Array.isArray(arr) && arr.length > 0;
const noTrendData = !trendLoading && !hasData(trend);

const noProductPieData =
  !productPieLoading && !hasData(productPie);

const noGeoData =
  !geoLoading && !hasData(geoTiles);

const noInsightsData =
  !hasData(byCustomer) &&
  !hasData(topProducts);

  // ✅ generate date array
const getDateRangeArray = (startDate, endDate) => {
  const dates = [];
  const current = new Date(startDate);
  const end = new Date(endDate);

  while (current <= end) {
    dates.push(current.toISOString().split("T")[0]);
    current.setDate(current.getDate() + 1);
  }

  return dates;
};

// ✅ get current week (Mon–Sun)
const getCurrentWeek = () => {
  const now = new Date();
  const day = now.getDay();
  const diffToMonday = day === 0 ? -6 : 1 - day;

  const monday = new Date(now);
  monday.setDate(now.getDate() + diffToMonday);

  const sunday = new Date(monday);
  sunday.setDate(monday.getDate() + 6);

  return {
    start: monday.toISOString().split("T")[0],
    end: sunday.toISOString().split("T")[0],
  };
};

const processedTrend = useMemo(() => {
  if (!startDate || !endDate) return trend;

  const start = startDate.toISOString().split("T")[0];
  const end = endDate.toISOString().split("T")[0];

  const fullDates = getDateRangeArray(start, end);

  const map = new Map(trend.map((t) => [t.date, t.revenue]));

  return fullDates.map((date) => ({
    date,
    revenue: map.get(date) || 0,
  }));
}, [trend, startDate, endDate]);

useEffect(() => {
  const week = getCurrentWeek();

  setStartDate(new Date(week.start));
  setEndDate(new Date(week.end));
}, []);

console.log("balanceAmount in companysales: ", balanceAmount)

  return (
      <div className="mx-auto space-y-4">
        
        <KpiSection kpis={kpis} loading={kpiLoading} balanceAmount={balanceAmount} walletLoading={walletLoading} handlePayment={handlePayment} fromUserView={fromUserView} selectedUserRole={selectedUserRole} selectedUserId={selectedUserId} selectedUserCompanyId={selectedUserCompanyId} walletPermissionLoading={walletPermissionLoading} shouldShowWallet={shouldShowWallet}/>

        {/* <FilterSection
          q={q} setQ={setQ}
          state={state} setState={setState}
          district={district} setDistrict={setDistrict}
          product={product} setProduct={setProduct}
          from={from} setFrom={setFrom}
          to={to} setTo={setTo}
          states={states}
          districts={districts}
          products={products}
        /> */}

        {isRetailerMobile && (
          <div className="mb-4">
            <div className="grid grid-cols-2
                            bg-white/10 backdrop-blur-2xl
                            border border-white/30
                            rounded-2xl p-2">

              {[
                { key: "trend", label: "Trend" },
                { key: "product", label: "Product" },
                // { key: "geo", label: "Geography" },
                // { key: "insight", label: "Insights" },
              ].map((tab) => (
                <button
                  key={tab.key}
                  onClick={() => setActiveTab(tab.key)}
                  className={`px-3 py-2 rounded-xl text-xs font-semibold transition-all
                    ${
                      activeTab === tab.key
                        ? "bg-gradient-to-br from-blue-600 to-indigo-700 text-white shadow-lg"
                        : "text-slate-800"
                    }`}
                >
                  {tab.label}
                </button>
              ))}
            </div>
          </div>
        )}

        {isRetailerMobile && activeTab === "trend" && (
            <TrendSection
            trend={processedTrend}
            loading={trendLoading}
            startDate={startDate}
            endDate={endDate}
            onDateChange={(start, end) => {
              setStartDate(start);
              setEndDate(end);
            }}
            productPie={productPie}
            topProduct={topProduct}
            lowProduct={lowProduct}
            noData={noTrendData && noProductPieData}
            showTrend={true}
            showProduct={false}
            isRetailerMobile={isRetailerMobile}
            />
        )}

        {isRetailerMobile && activeTab === "product" && (
         <TrendSection
            trend={processedTrend}
            loading={trendLoading}
            productPie={productPie}
            topProduct={topProduct}
            lowProduct={lowProduct}
            noData={noTrendData && noProductPieData}
            showTrend={false}
            showProduct={true}
            isRetailerMobile={isRetailerMobile}

          />
        )}

        {isRetailerMobile && activeTab === "geo" && (
          <GeographySection
          mode={mode}
          setMode={setMode}
          loading={geoLoading}
          /* API-driven */
          byState={mode === "state" ? geoTiles : []}
          byDistrict={mode === "district" ? geoTiles : []}
          topStates={mode === "state" ? geoBars : []}
          topDistricts={mode === "district" ? geoBars : []}
          maxMapValue={maxMapValue}
          isRetailerMobile={isRetailerMobile}

          /* selection */
          state={state}
          setState={setState}
          district={district}
          setDistrict={setDistrict}
          noData={noGeoData}

        />
        )}

        {isRetailerMobile && activeTab === "insight" && (
          <InsightsSection
          topProduct={topProduct}
          lowProduct={lowProduct}
          topProducts={topProducts}
          byCustomer={byCustomer}
          mostClaims={mostClaims}
          mostCreditNotes={mostCreditNotes}
          kpis={kpis}
          mode={mode}
          byState={mode === "state" ? geoTiles : []}
          byDistrict={mode === "district" ? geoTiles : []}
          noData={noInsightsData}
          // byState={byState}
          // byDistrict={byDistrict}
        />
        )}
        {!isRetailerMobile && (
          <>

        <TrendSection
          trend={processedTrend}
          loading={trendLoading}
          startDate={startDate}
          endDate={endDate}
          onDateChange={(start, end) => {
            setStartDate(start);
            setEndDate(end);
          }}
          productPie={productPie}
          topProduct={topProduct}
          lowProduct={lowProduct}
          noData={noTrendData && noProductPieData}
        />

        <GeographySection
          mode={mode}
          setMode={setMode}
          loading={geoLoading}
          /* API-driven */
          byState={mode === "state" ? geoTiles : []}
          byDistrict={mode === "district" ? geoTiles : []}
          topStates={mode === "state" ? geoBars : []}
          topDistricts={mode === "district" ? geoBars : []}
          maxMapValue={maxMapValue}

          /* selection */
          state={state}
          setState={setState}
          district={district}
          setDistrict={setDistrict}
          noData={noGeoData}

        />


        <InsightsSection
          topProduct={topProduct}
          lowProduct={lowProduct}
          topProducts={topProducts}
          byCustomer={byCustomer}
          mostClaims={mostClaims}
          mostCreditNotes={mostCreditNotes}
          kpis={kpis}
          mode={mode}
          byState={mode === "state" ? geoTiles : []}
          byDistrict={mode === "district" ? geoTiles : []}
          noData={noInsightsData}
          // byState={byState}
          // byDistrict={byDistrict}
        />

        {/* <SummaryTableSection
          mode={mode}
          byState={byState}
          byDistrict={byDistrict}
        /> */}

        </>
        )}
      </div>
    );
}


// import React, { useMemo, useState, useEffect } from "react";
// import { useLocation, useParams } from "react-router-dom";

// import KpiSection from "./KpiSection";
// import { FilterSection } from "./FilterSection";
// import TrendSection from "./TrendSection";
// import GeographySection from "./GeographySection";
// import InsightsSection from "./InsightsSection";
// import SummaryTableSection from "./SummaryTableSection";
// import { classNames, isBetween } from "../../../utils/helpers";
// import { BASE_URL } from "../../../config/api";

// /** ---------- page ---------- */
// export default function CompanySales() {
  
//   const { id } = useParams();
//   const location = useLocation();
//   const [trend, setTrend] = useState([]);
//   const [trendLoading, setTrendLoading] = useState(false);
//   const [productPie, setProductPie] = useState([]);
//   const [topProduct, setTopProduct] = useState(null);
//   const [lowProduct, setLowProduct] = useState(null);
//   const [productPieLoading, setProductPieLoading] = useState(false);

//   const [geoBars, setGeoBars] = useState([]);
//   const [geoTiles, setGeoTiles] = useState([]);
//   const [geoTop, setGeoTop] = useState(null);
//   const [geoLoading, setGeoLoading] = useState(false);
//   const [mode, setMode] = useState("state");
//   const [payoutSummary, setPayoutSummary] = useState({
//   total_sales: 0,
//   pending_invoices: { count: 0, amount: 0 },
//   credit_notes: 0,
//   warranty_submitted: 0,
//   payable_amount: 0,
//   paid_amount: 0,
//   my_earnings: 0,
// });

// useEffect(() => {
//   const fetchPayoutSummary = async () => {
//     try {
//       const authUser = JSON.parse(localStorage.getItem("authUserData"));
//       const retailerId = authUser?.id;

//       if (!retailerId) return;

//       const res = await fetch(
//         `${BASE_URL}warranty/payout-summary?retailer_id=${retailerId}`
//       );

//       const json = await res.json();

//       if (!res.ok || !json.status) {
//         throw new Error("Failed to fetch payout summary");
//       }

//       setPayoutSummary({
//         total_sales: json.data?.total_sales ?? 0,
//         pending_invoices: {
//           count: json.data?.pending_invoices?.count ?? 0,
//           amount: json.data?.pending_invoices?.amount ?? 0,
//         },
//         credit_notes: json.data?.credit_notes ?? 0,
//         warranty_submitted: json.data?.warranty_submitted ?? 0,
//         payable_amount: json.data?.payable_amount ?? 0,
//         paid_amount: json.data?.paid_amount ?? 0,
//         my_earnings: json.data?.my_earnings ?? 0,
//       });

//     } catch (err) {
//       console.error("Payout summary error:", err);
//     }
//   };

//   fetchPayoutSummary();
// }, []);


// useEffect(() => {
//   const fetchProductRevenueShare = async () => {
//     try {
//       setProductPieLoading(true);

//       const authUser = JSON.parse(localStorage.getItem("authUserData"));
//       const retailerId = authUser?.id;
//       if (!retailerId) return;

//       const res = await fetch(
//         `${BASE_URL}warranty/charts/product-revenue-share?retailer_id=${retailerId}`
//       );

//       const json = await res.json();

//       if (!res.ok || !json.status) {
//         throw new Error("Failed to fetch product revenue share");
//       }

//       /* ---- Transform API → Recharts Pie format ---- */
//       setProductPie(
//         (json.data || []).map((p) => ({
//           name: p.product_name,
//           value: p.revenue,
//         }))
//       );

//       setTopProduct(
//         json.top_product
//           ? { name: json.top_product.product_name, revenue: json.top_product.revenue }
//           : null
//       );

//       setLowProduct(
//         json.low_product
//           ? { name: json.low_product.product_name, revenue: json.low_product.revenue }
//           : null
//       );

//     } catch (err) {
//       console.error("Product revenue share error:", err);
//       setProductPie([]);
//       setTopProduct(null);
//       setLowProduct(null);
//     } finally {
//       setProductPieLoading(false);
//     }
//   };

//   fetchProductRevenueShare();
// }, []);


// useEffect(() => {
//   const fetchGeographyRevenue = async () => {
//     try {
//       setGeoLoading(true);

//       const authUser = JSON.parse(localStorage.getItem("authUserData"));
//       const retailerId = authUser?.id;
//       if (!retailerId) return;

//       const res = await fetch(
//         `${BASE_URL}warranty/charts/geography-revenue?retailer_id=${retailerId}&type=${mode}`
//       );

//       const json = await res.json();

//       if (!res.ok || !json.status) {
//         throw new Error("Failed to fetch geography revenue");
//       }

//       /* ---- Bar chart data ---- */
//       setGeoBars(
//         json.chart.labels.map((label, idx) => ({
//           name: label,
//           revenue: json.chart.values[idx],
//         }))
//       );

//       /* ---- Heat tiles ---- */
//       setGeoTiles(json.tiles || []);

//       /* ---- Top label ---- */
//       setGeoTop(json.top || null);

//     } catch (err) {
//       console.error("Geography revenue error:", err);
//       setGeoBars([]);
//       setGeoTiles([]);
//       setGeoTop(null);
//     } finally {
//       setGeoLoading(false);
//     }
//   };

//   fetchGeographyRevenue();
// }, [mode]);

//   // company name header (same pattern as your invoices)
//   const companyObj = location.state?.c || location.state?.company || null;
//   const companyName =
//     companyObj?.business_name || companyObj?.name || location.state?.companyName || "Company";

//   /** Mock transactions data (replace with API) */
//   const raw = useMemo(
//     () => [
//       // date, state, district, product, amount, units, customerCode, customerName, creditNote, claimCount
//       { date: "2025-10-01", state: "MAHARASHTRA", district: "RAIGAD", product: "iPhone 13", amount: 320000, units: 8, customerCode: "CUST-001", customerName: "A Retail", creditNote: 8000, claimCount: 3 },
//       { date: "2025-10-02", state: "MAHARASHTRA", district: "THANE", product: "Samsung S22", amount: 210000, units: 7, customerCode: "CUST-002", customerName: "B Store", creditNote: 0, claimCount: 1 },
//       { date: "2025-10-05", state: "GUJARAT", district: "VALSAD", product: "iPhone 13", amount: 180000, units: 5, customerCode: "CUST-003", customerName: "C Mobile", creditNote: 6000, claimCount: 2 },
//       { date: "2025-10-08", state: "GUJARAT", district: "SURAT", product: "OnePlus 11", amount: 145000, units: 5, customerCode: "CUST-004", customerName: "D Hub", creditNote: 2000, claimCount: 1 },
//       { date: "2025-10-11", state: "KARNATAKA", district: "BENGALURU", product: "Samsung S22", amount: 260000, units: 9, customerCode: "CUST-001", customerName: "A Retail", creditNote: 5000, claimCount: 4 },
//       { date: "2025-10-14", state: "KARNATAKA", district: "MYSURU", product: "Vivo V29", amount: 95000, units: 5, customerCode: "CUST-005", customerName: "E Phones", creditNote: 0, claimCount: 1 },
//       { date: "2025-10-19", state: "MAHARASHTRA", district: "RAIGAD", product: "OnePlus 11", amount: 120000, units: 4, customerCode: "CUST-006", customerName: "F Corner", creditNote: 0, claimCount: 0 },
//       { date: "2025-10-22", state: "GUJARAT", district: "SURAT", product: "Vivo V29", amount: 80000, units: 4, customerCode: "CUST-002", customerName: "B Store", creditNote: 3000, claimCount: 2 },
//       { date: "2025-10-25", state: "MAHARASHTRA", district: "THANE", product: "iPhone 13", amount: 240000, units: 6, customerCode: "CUST-007", customerName: "G Mart", creditNote: 9000, claimCount: 2 },
//       { date: "2025-10-29", state: "KARNATAKA", district: "BENGALURU", product: "iPhone 13", amount: 200000, units: 5, customerCode: "CUST-008", customerName: "H Shop", creditNote: 0, claimCount: 1 },
//     ],
//     []
//   );

//   /** Filters */
//   // state | district
//   const [q, setQ] = useState("");
//   const [state, setState] = useState("ALL");
//   const [district, setDistrict] = useState("ALL");
//   const [product, setProduct] = useState("ALL");
//   const [from, setFrom] = useState("");
//   const [to, setTo] = useState("");

//   // reset district when state changes
//   useEffect(() => setDistrict("ALL"), [state]);

//   const states = useMemo(() => ["ALL", ...Array.from(new Set(raw.map(r => r.state))).sort()], [raw]);
//   const districts = useMemo(() => {
//     const list = raw
//       .filter(r => state === "ALL" ? true : r.state === state)
//       .map(r => r.district);
//     return ["ALL", ...Array.from(new Set(list)).sort()];
//   }, [raw, state]);
//   const products = useMemo(() => ["ALL", ...Array.from(new Set(raw.map(r => r.product))).sort()], [raw]);

//   const filtered = useMemo(() => {
//     const s = q.trim().toLowerCase();
//     return raw.filter(r => {
//       if (!isBetween(r.date, from, to)) return false;
//       if (state !== "ALL" && r.state !== state) return false;
//       if (district !== "ALL" && r.district !== district) return false;
//       if (product !== "ALL" && r.product !== product) return false;

//       if (s) {
//         const hay = [r.state, r.district, r.product, r.customerCode, r.customerName, r.date]
//           .filter(Boolean).join(" ").toLowerCase();
//         if (!hay.includes(s)) return false;
//       }
//       return true;
//     });
//   }, [raw, q, state, district, product, from, to]);

//   /** KPIs */
//   const kpis = useMemo(() => {
//   const revenue = payoutSummary.total_sales ?? 0;
//   const creditNotes = payoutSummary.credit_notes ?? 0;

//   return {
//     revenue,
//     units: payoutSummary.pending_invoices?.count ?? 0,
//     uninvoicedAmount:payoutSummary.pending_invoices?.amount ?? 0,
//     creditNotes,
//     creditRatio: revenue > 0 ? creditNotes / revenue : 0,
//     claims: payoutSummary.warranty_submitted ?? 0,
//     payableAmount: payoutSummary.payable_amount ?? 0,
//     paidAmount: payoutSummary.paid_amount ?? 0,
//     myEarnings: payoutSummary.my_earnings ?? 0,
//   };
// }, [payoutSummary]);


//   /** Aggregate: state & district */
//   // const byState = useMemo(() => {
//   //   const map = new Map();
//   //   filtered.forEach(r => {
//   //     const k = r.state;
//   //     const prev = map.get(k) || { name: k, revenue: 0, units: 0, creditNotes: 0, claims: 0 };
//   //     prev.revenue += r.amount;
//   //     prev.units += r.units;
//   //     prev.creditNotes += r.creditNote;
//   //     prev.claims += r.claimCount;
//   //     map.set(k, prev);
//   //   });
//   //   return Array.from(map.values()).sort((a,b) => b.revenue - a.revenue);
//   // }, [filtered]);

//   // const byDistrict = useMemo(() => {
//   //   const map = new Map();
//   //   filtered.forEach(r => {
//   //     const k = `${r.state} • ${r.district}`;
//   //     const prev = map.get(k) || { name: r.district, state: r.state, key: k, revenue: 0, units: 0, creditNotes: 0, claims: 0 };
//   //     prev.revenue += r.amount;
//   //     prev.units += r.units;
//   //     prev.creditNotes += r.creditNote;
//   //     prev.claims += r.claimCount;
//   //     map.set(k, prev);
//   //   });
//   //   return Array.from(map.values()).sort((a,b) => b.revenue - a.revenue);
//   // }, [filtered]);

//   /** Product comparison (overall + within selected state/district already via filtered) */
//   const byProduct = useMemo(() => {
//     const map = new Map();
//     filtered.forEach(r => {
//       const k = r.product;
//       const prev = map.get(k) || { name: k, revenue: 0, units: 0 };
//       prev.revenue += r.amount;
//       prev.units += r.units;
//       map.set(k, prev);
//     });
//     return Array.from(map.values()).sort((a,b) => b.revenue - a.revenue);
//   }, [filtered]);

//   // const topProduct = byProduct[0];
//   // const lowProduct = byProduct[byProduct.length - 1];

//   /** Who mostly sale/claim */
//   const byCustomer = useMemo(() => {
//     const map = new Map();
//     filtered.forEach(r => {
//       const k = r.customerCode || r.customerName;
//       const prev = map.get(k) || { code: r.customerCode || "—", name: r.customerName || "—", revenue: 0, claims: 0, creditNotes: 0 };
//       prev.revenue += r.amount;
//       prev.claims += r.claimCount;
//       prev.creditNotes += r.creditNote;
//       map.set(k, prev);
//     });
//     return Array.from(map.values()).sort((a,b) => b.revenue - a.revenue);
//   }, [filtered]);

//   const mostClaims = useMemo(() => [...byCustomer].sort((a,b) => b.claims - a.claims).slice(0,5), [byCustomer]);
//   const mostCreditNotes = useMemo(() => [...byCustomer].sort((a,b) => b.creditNotes - a.creditNotes).slice(0,5), [byCustomer]);

//   /** Trend line (revenue by date) */
//   // const trend = useMemo(() => {
//   //   const map = new Map();
//   //   filtered.forEach(r => {
//   //     const k = r.date;
//   //     map.set(k, (map.get(k) || 0) + r.amount);
//   //   });
//   //   return Array.from(map.entries())
//   //     .sort((a,b) => a[0].localeCompare(b[0]))
//   //     .map(([date, revenue]) => ({ date, revenue }));
//   // }, [filtered]);

//   /** “Map tiles” data */
//   // const mapData = mode === "state" ? byState : byDistrict.map(d => ({ name: d.key, revenue: d.revenue }));
//   // const maxMapValue = useMemo(() => mapData.reduce((m, x) => Math.max(m, x.revenue || 0), 0), [mapData]);
//   const maxMapValue = useMemo(
//   () => geoTiles.reduce((m, x) => Math.max(m, x.revenue || 0), 0),
//   [geoTiles]
// );


//   /** Chart data (top N for readability) */
//   // const topStates = byState.slice(0, 8);
//   // const topDistricts = byDistrict.slice(0, 10);
//   const topProducts = byProduct.slice(0, 8);

//   /** Pie: revenue share by product (top 5 + others) */
//   // const productPie = useMemo(() => {
//   //   const top = byProduct.slice(0, 5);
//   //   const rest = byProduct.slice(5).reduce((a, p) => a + p.revenue, 0);
//   //   const arr = top.map(p => ({ name: p.name, value: p.revenue }));
//   //   if (rest > 0) arr.push({ name: "Others", value: rest });
//   //   return arr;
//   // }, [byProduct]);


//   useEffect(() => {
//   const fetchRevenueTrend = async () => {
//     try {
//       setTrendLoading(true);

//       const authUser = JSON.parse(localStorage.getItem("authUserData"));
//       const retailerId = authUser?.id;
//       if (!retailerId) return;

//       const res = await fetch(
//         `${BASE_URL}warranty/charts/revenue-trend?retailer_id=${retailerId}`
//       );

//       const json = await res.json();

//       if (!res.ok || !json.status) {
//         throw new Error("Failed to fetch revenue trend");
//       }

//       // API already matches recharts format
//       setTrend(json.data || []);
//     } catch (err) {
//       console.error("Revenue trend error:", err);
//       setTrend([]);
//     } finally {
//       setTrendLoading(false);
//     }
//   };

//   fetchRevenueTrend();
// }, []);


//   return (
//       <div className="mx-auto space-y-4">
        
//         <KpiSection kpis={kpis} />

//         <FilterSection
//           q={q} setQ={setQ}
//           state={state} setState={setState}
//           district={district} setDistrict={setDistrict}
//           product={product} setProduct={setProduct}
//           from={from} setFrom={setFrom}
//           to={to} setTo={setTo}
//           states={states}
//           districts={districts}
//           products={products}
//         />

//         <TrendSection
//           trend={trend}
//           loading={trendLoading}
//           productPie={productPie}
//           topProduct={topProduct}
//           lowProduct={lowProduct}
//         />

//         <GeographySection
//           mode={mode}
//           setMode={setMode}

//           /* API-driven */
//           byState={mode === "state" ? geoTiles : []}
//           byDistrict={mode === "district" ? geoTiles : []}
//           topStates={mode === "state" ? geoBars : []}
//           topDistricts={mode === "district" ? geoBars : []}
//           maxMapValue={maxMapValue}

//           /* selection */
//           state={state}
//           setState={setState}
//           district={district}
//           setDistrict={setDistrict}
//         />


//         <InsightsSection
//           topProduct={topProduct}
//           lowProduct={lowProduct}
//           topProducts={topProducts}
//           byCustomer={byCustomer}
//           mostClaims={mostClaims}
//           mostCreditNotes={mostCreditNotes}
//           kpis={kpis}
//           mode={mode}
//           byState={mode === "state" ? geoTiles : []}
//           byDistrict={mode === "district" ? geoTiles : []}
//           // byState={byState}
//           // byDistrict={byDistrict}
//         />

//         {/* <SummaryTableSection
//           mode={mode}
//           byState={byState}
//           byDistrict={byDistrict}
//         /> */}
//       </div>
//     );
// }



// import React, { useMemo, useState, useEffect } from "react";
// import { useLocation, useParams } from "react-router-dom";
// import {
//   Building2,
//   Search,
//   CalendarDays,
//   Filter,
//   TrendingUp,
//   TrendingDown,
//   BadgeIndianRupee,
//   Percent,
//   Users,
//   Boxes,
//   FileText,
// } from "lucide-react";

// import {
//   ResponsiveContainer,
//   BarChart,
//   Bar,
//   XAxis,
//   YAxis,
//   Tooltip,
//   Legend,
//   PieChart,
//   Pie,
//   Cell,
//   LineChart,
//   Line,
//   CartesianGrid,
// } from "recharts";

// /** ---------- helpers ---------- */
// const money = (n) => `₹${Number(n || 0).toLocaleString()}`;
// const pct = (n) => `${(Number(n || 0) * 100).toFixed(1)}%`;

// function parseDate(dateStr) {
//   if (!dateStr) return null;
//   const d = new Date(dateStr);
//   return Number.isNaN(d.getTime()) ? null : d;
// }
// function isBetween(dateStr, from, to) {
//   const d = parseDate(dateStr);
//   if (!d) return true;
//   const start = from ? parseDate(from) : null;
//   const end = to ? parseDate(to) : null;

//   if (start && d < start) return false;
//   if (end) {
//     const endDay = new Date(end);
//     endDay.setHours(23, 59, 59, 999);
//     if (d > endDay) return false;
//   }
//   return true;
// }
// function classNames(...x) {
//   return x.filter(Boolean).join(" ");
// }

// /** ---------- tiny UI atoms ---------- */
// function Card({ title, right, children }) {
//   return (
//     <div className="rounded-2xl border border-blue-100 bg-white p-5 shadow-sm">
//       <div className="mb-4 flex flex-wrap items-start justify-between gap-3">
//         <div>
//           <p className="text-base font-semibold text-slate-900">{title}</p>
//         </div>
//         {right}
//       </div>
//       {children}
//     </div>
//   );
// }

// function Kpi({ icon: Icon, label, value, sub }) {
//   return (
//     <div className="rounded-2xl border border-blue-100 bg-white p-4 shadow-sm">
//       <div className="flex items-start justify-between gap-3">
//         <div>
//           <p className="text-xs font-semibold text-slate-500">{label}</p>
//           <p className="mt-1 text-lg font-semibold text-slate-900">{value}</p>
//           {sub ? <p className="mt-1 text-xs font-semibold text-slate-600">{sub}</p> : null}
//         </div>
//         <div className="rounded-2xl bg-blue-50 p-3 text-blue-700">
//           <Icon className="h-5 w-5" />
//         </div>
//       </div>
//     </div>
//   );
// }

// function Chip({ active, children, onClick }) {
//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className={classNames(
//         "whitespace-nowrap rounded-xl px-4 py-2 text-sm font-semibold transition",
//         active ? "bg-blue-600 text-white" : "bg-blue-50 text-blue-700 hover:bg-blue-100"
//       )}
//     >
//       {children}
//     </button>
//   );
// }

// function HeatTile({ name, value, max, onClick, active }) {
//   const intensity = max > 0 ? value / max : 0;
//   // purely tailwind: keep simple 4 steps
//   const level =
//     intensity >= 0.75 ? "bg-blue-600 text-white" :
//     intensity >= 0.5 ? "bg-blue-400 text-white" :
//     intensity >= 0.25 ? "bg-blue-200 text-blue-900" :
//     "bg-blue-50 text-blue-700";

//   return (
//     <button
//       type="button"
//       onClick={onClick}
//       className={classNames(
//         "flex flex-col gap-1 rounded-2xl border border-blue-100 p-3 text-left transition hover:shadow-sm",
//         level,
//         active ? "ring-2 ring-blue-300" : ""
//       )}
//       title={`${name} • ${money(value)}`}
//     >
//       <p className="text-xs font-semibold opacity-90">{name}</p>
//       <p className="text-sm font-semibold">{money(value)}</p>
//     </button>
//   );
// }

// /** ---------- page ---------- */
// export default function CompanySales() {
//   const { id } = useParams();
//   const location = useLocation();

//   // company name header (same pattern as your invoices)
//   const companyObj = location.state?.c || location.state?.company || null;
//   const companyName =
//     companyObj?.business_name || companyObj?.name || location.state?.companyName || "Company";

//   /** Mock transactions data (replace with API) */
//   const raw = useMemo(
//     () => [
//       // date, state, district, product, amount, units, customerCode, customerName, creditNote, claimCount
//       { date: "2025-10-01", state: "MAHARASHTRA", district: "RAIGAD", product: "iPhone 13", amount: 320000, units: 8, customerCode: "CUST-001", customerName: "A Retail", creditNote: 8000, claimCount: 3 },
//       { date: "2025-10-02", state: "MAHARASHTRA", district: "THANE", product: "Samsung S22", amount: 210000, units: 7, customerCode: "CUST-002", customerName: "B Store", creditNote: 0, claimCount: 1 },
//       { date: "2025-10-05", state: "GUJARAT", district: "VALSAD", product: "iPhone 13", amount: 180000, units: 5, customerCode: "CUST-003", customerName: "C Mobile", creditNote: 6000, claimCount: 2 },
//       { date: "2025-10-08", state: "GUJARAT", district: "SURAT", product: "OnePlus 11", amount: 145000, units: 5, customerCode: "CUST-004", customerName: "D Hub", creditNote: 2000, claimCount: 1 },
//       { date: "2025-10-11", state: "KARNATAKA", district: "BENGALURU", product: "Samsung S22", amount: 260000, units: 9, customerCode: "CUST-001", customerName: "A Retail", creditNote: 5000, claimCount: 4 },
//       { date: "2025-10-14", state: "KARNATAKA", district: "MYSURU", product: "Vivo V29", amount: 95000, units: 5, customerCode: "CUST-005", customerName: "E Phones", creditNote: 0, claimCount: 1 },
//       { date: "2025-10-19", state: "MAHARASHTRA", district: "RAIGAD", product: "OnePlus 11", amount: 120000, units: 4, customerCode: "CUST-006", customerName: "F Corner", creditNote: 0, claimCount: 0 },
//       { date: "2025-10-22", state: "GUJARAT", district: "SURAT", product: "Vivo V29", amount: 80000, units: 4, customerCode: "CUST-002", customerName: "B Store", creditNote: 3000, claimCount: 2 },
//       { date: "2025-10-25", state: "MAHARASHTRA", district: "THANE", product: "iPhone 13", amount: 240000, units: 6, customerCode: "CUST-007", customerName: "G Mart", creditNote: 9000, claimCount: 2 },
//       { date: "2025-10-29", state: "KARNATAKA", district: "BENGALURU", product: "iPhone 13", amount: 200000, units: 5, customerCode: "CUST-008", customerName: "H Shop", creditNote: 0, claimCount: 1 },
//     ],
//     []
//   );

//   /** Filters */
//   const [mode, setMode] = useState("state"); // state | district
//   const [q, setQ] = useState("");
//   const [state, setState] = useState("ALL");
//   const [district, setDistrict] = useState("ALL");
//   const [product, setProduct] = useState("ALL");
//   const [from, setFrom] = useState("");
//   const [to, setTo] = useState("");

//   // reset district when state changes
//   useEffect(() => setDistrict("ALL"), [state]);

//   const states = useMemo(() => ["ALL", ...Array.from(new Set(raw.map(r => r.state))).sort()], [raw]);
//   const districts = useMemo(() => {
//     const list = raw
//       .filter(r => state === "ALL" ? true : r.state === state)
//       .map(r => r.district);
//     return ["ALL", ...Array.from(new Set(list)).sort()];
//   }, [raw, state]);
//   const products = useMemo(() => ["ALL", ...Array.from(new Set(raw.map(r => r.product))).sort()], [raw]);

//   const filtered = useMemo(() => {
//     const s = q.trim().toLowerCase();
//     return raw.filter(r => {
//       if (!isBetween(r.date, from, to)) return false;
//       if (state !== "ALL" && r.state !== state) return false;
//       if (district !== "ALL" && r.district !== district) return false;
//       if (product !== "ALL" && r.product !== product) return false;

//       if (s) {
//         const hay = [r.state, r.district, r.product, r.customerCode, r.customerName, r.date]
//           .filter(Boolean).join(" ").toLowerCase();
//         if (!hay.includes(s)) return false;
//       }
//       return true;
//     });
//   }, [raw, q, state, district, product, from, to]);

//   /** KPIs */
//   const kpis = useMemo(() => {
//     const revenue = filtered.reduce((a, r) => a + r.amount, 0);
//     const units = filtered.reduce((a, r) => a + r.units, 0);
//     const creditNotes = filtered.reduce((a, r) => a + r.creditNote, 0);
//     const claims = filtered.reduce((a, r) => a + r.claimCount, 0);

//     const creditRatio = revenue > 0 ? creditNotes / revenue : 0;
//     return { revenue, units, creditNotes, creditRatio, claims };
//   }, [filtered]);

//   /** Aggregate: state & district */
//   const byState = useMemo(() => {
//     const map = new Map();
//     filtered.forEach(r => {
//       const k = r.state;
//       const prev = map.get(k) || { name: k, revenue: 0, units: 0, creditNotes: 0, claims: 0 };
//       prev.revenue += r.amount;
//       prev.units += r.units;
//       prev.creditNotes += r.creditNote;
//       prev.claims += r.claimCount;
//       map.set(k, prev);
//     });
//     return Array.from(map.values()).sort((a,b) => b.revenue - a.revenue);
//   }, [filtered]);

//   const byDistrict = useMemo(() => {
//     const map = new Map();
//     filtered.forEach(r => {
//       const k = `${r.state} • ${r.district}`;
//       const prev = map.get(k) || { name: r.district, state: r.state, key: k, revenue: 0, units: 0, creditNotes: 0, claims: 0 };
//       prev.revenue += r.amount;
//       prev.units += r.units;
//       prev.creditNotes += r.creditNote;
//       prev.claims += r.claimCount;
//       map.set(k, prev);
//     });
//     return Array.from(map.values()).sort((a,b) => b.revenue - a.revenue);
//   }, [filtered]);

//   /** Product comparison (overall + within selected state/district already via filtered) */
//   const byProduct = useMemo(() => {
//     const map = new Map();
//     filtered.forEach(r => {
//       const k = r.product;
//       const prev = map.get(k) || { name: k, revenue: 0, units: 0 };
//       prev.revenue += r.amount;
//       prev.units += r.units;
//       map.set(k, prev);
//     });
//     return Array.from(map.values()).sort((a,b) => b.revenue - a.revenue);
//   }, [filtered]);

//   const topProduct = byProduct[0];
//   const lowProduct = byProduct[byProduct.length - 1];

//   /** Who mostly sale/claim */
//   const byCustomer = useMemo(() => {
//     const map = new Map();
//     filtered.forEach(r => {
//       const k = r.customerCode || r.customerName;
//       const prev = map.get(k) || { code: r.customerCode || "—", name: r.customerName || "—", revenue: 0, claims: 0, creditNotes: 0 };
//       prev.revenue += r.amount;
//       prev.claims += r.claimCount;
//       prev.creditNotes += r.creditNote;
//       map.set(k, prev);
//     });
//     return Array.from(map.values()).sort((a,b) => b.revenue - a.revenue);
//   }, [filtered]);

//   const mostClaims = useMemo(() => [...byCustomer].sort((a,b) => b.claims - a.claims).slice(0,5), [byCustomer]);
//   const mostCreditNotes = useMemo(() => [...byCustomer].sort((a,b) => b.creditNotes - a.creditNotes).slice(0,5), [byCustomer]);

//   /** Trend line (revenue by date) */
//   const trend = useMemo(() => {
//     const map = new Map();
//     filtered.forEach(r => {
//       const k = r.date;
//       map.set(k, (map.get(k) || 0) + r.amount);
//     });
//     return Array.from(map.entries())
//       .sort((a,b) => a[0].localeCompare(b[0]))
//       .map(([date, revenue]) => ({ date, revenue }));
//   }, [filtered]);

//   /** “Map tiles” data */
//   const mapData = mode === "state" ? byState : byDistrict.map(d => ({ name: d.key, revenue: d.revenue }));
//   const maxMapValue = useMemo(() => mapData.reduce((m, x) => Math.max(m, x.revenue || 0), 0), [mapData]);

//   /** Chart data (top N for readability) */
//   const topStates = byState.slice(0, 8);
//   const topDistricts = byDistrict.slice(0, 10);
//   const topProducts = byProduct.slice(0, 8);

//   /** Pie: revenue share by product (top 5 + others) */
//   const productPie = useMemo(() => {
//     const top = byProduct.slice(0, 5);
//     const rest = byProduct.slice(5).reduce((a, p) => a + p.revenue, 0);
//     const arr = top.map(p => ({ name: p.name, value: p.revenue }));
//     if (rest > 0) arr.push({ name: "Others", value: rest });
//     return arr;
//   }, [byProduct]);

//   return (
//     <div className="mx-auto space-y-4 p-4 md:p-8">
//       {/* Company header */}
//       {/* <div className="rounded-2xl border border-blue-100 bg-white p-4 shadow-sm">
//         <div className="flex flex-wrap items-center justify-between gap-3">
//           <div className="flex items-center gap-3">
//             <div className="rounded-2xl bg-blue-50 p-3 text-blue-700">
//               <Building2 className="h-5 w-5" />
//             </div>
//             <div>
//               <p className="text-xs font-semibold text-slate-500">Company</p>
//               <p className="text-base font-semibold text-slate-900">{companyName}</p>
//               <p className="text-xs font-semibold text-slate-500">Company ID: {id}</p>
//             </div>
//           </div>

//           <div className="flex items-center gap-2">
//             <span className="rounded-xl border border-blue-100 bg-blue-50 px-3 py-2 text-xs font-semibold text-blue-700">
//               Records: {filtered.length}
//             </span>
//           </div>
//         </div>
//       </div> */}

//       {/* KPIs */}
//       <div className="grid grid-cols-2 gap-3 md:grid-cols-5">
//         <Kpi icon={BadgeIndianRupee} label="Revenue" value={money(kpis.revenue)} sub="Filtered total" />
//         <Kpi icon={Boxes} label="Units Sold" value={String(kpis.units)} sub="Total units" />
//         <Kpi icon={FileText} label="Credit Notes" value={money(kpis.creditNotes)} sub="Total CN amount" />
//         <Kpi icon={Percent} label="CN Ratio" value={pct(kpis.creditRatio)} sub="CN / Revenue" />
//         <Kpi icon={Users} label="Claims" value={String(kpis.claims)} sub="Total claims" />
//       </div>

//       {/* Filters */}
//       <Card
//         title="Filters"
//         right={
//           <div className="flex items-center gap-2">
//             <span className="inline-flex items-center gap-2 rounded-xl border border-blue-100 bg-blue-50 px-3 py-2 text-xs font-semibold text-blue-700">
//               <Filter className="h-4 w-4" />
//               Smart Filters
//             </span>
//           </div>
//         }
//       >
//         <div className="grid grid-cols-1 gap-3 md:grid-cols-12">
//           {/* search */}
//           <div className="md:col-span-4">
//             <label className="mb-1 block text-xs font-semibold text-slate-600">Search</label>
//             <div className="relative">
//               <Search className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
//               <input
//                 value={q}
//                 onChange={(e) => setQ(e.target.value)}
//                 placeholder="state / district / product / customer..."
//                 className="w-full rounded-xl border border-blue-100 bg-white py-2 pl-10 pr-3 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-200"
//               />
//             </div>
//           </div>

//           {/* state */}
//           <div className="md:col-span-2">
//             <label className="mb-1 block text-xs font-semibold text-slate-600">State</label>
//             <select
//               value={state}
//               onChange={(e) => setState(e.target.value)}
//               className="w-full rounded-xl border border-blue-100 bg-white px-3 py-2 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-200"
//             >
//               {states.map(s => <option key={s} value={s}>{s}</option>)}
//             </select>
//           </div>

//           {/* district */}
//           <div className="md:col-span-2">
//             <label className="mb-1 block text-xs font-semibold text-slate-600">District</label>
//             <select
//               value={district}
//               onChange={(e) => setDistrict(e.target.value)}
//               className="w-full rounded-xl border border-blue-100 bg-white px-3 py-2 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-200"
//             >
//               {districts.map(d => <option key={d} value={d}>{d}</option>)}
//             </select>
//           </div>

//           {/* product */}
//           <div className="md:col-span-2">
//             <label className="mb-1 block text-xs font-semibold text-slate-600">Product</label>
//             <select
//               value={product}
//               onChange={(e) => setProduct(e.target.value)}
//               className="w-full rounded-xl border border-blue-100 bg-white px-3 py-2 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-200"
//             >
//               {products.map(p => <option key={p} value={p}>{p}</option>)}
//             </select>
//           </div>

//           {/* dates */}
//           <div className="md:col-span-2">
//             <label className="mb-1 block text-xs font-semibold text-slate-600">From</label>
//             <div className="relative">
//               <CalendarDays className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
//               <input
//                 type="date"
//                 value={from}
//                 onChange={(e) => setFrom(e.target.value)}
//                 className="w-full rounded-xl border border-blue-100 bg-white py-2 pl-10 pr-3 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-200"
//               />
//             </div>
//           </div>

//           <div className="md:col-span-2">
//             <label className="mb-1 block text-xs font-semibold text-slate-600">To</label>
//             <div className="relative">
//               <CalendarDays className="absolute left-3 top-1/2 h-4 w-4 -translate-y-1/2 text-slate-400" />
//               <input
//                 type="date"
//                 value={to}
//                 onChange={(e) => setTo(e.target.value)}
//                 className="w-full rounded-xl border border-blue-100 bg-white py-2 pl-10 pr-3 text-sm font-semibold text-slate-900 focus:outline-none focus:ring-2 focus:ring-blue-200"
//               />
//             </div>
//           </div>

//           <div className="md:col-span-2 flex items-end gap-2">
//             <button
//               type="button"
//               onClick={() => {
//                 setQ(""); setState("ALL"); setDistrict("ALL"); setProduct("ALL"); setFrom(""); setTo("");
//               }}
//               className="w-full rounded-xl border border-blue-200 bg-blue-50 px-4 py-2 text-sm font-semibold text-blue-700 hover:bg-blue-100"
//             >
//               Clear
//             </button>
//           </div>
//         </div>
//       </Card>

//       {/* Trend + Product mix */}
//       <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
//         <Card title="Revenue Trend">
//           <div className="h-72">
//             <ResponsiveContainer width="100%" height="100%">
//               <LineChart data={trend}>
//                 <CartesianGrid strokeDasharray="3 3" />
//                 <XAxis dataKey="date" />
//                 <YAxis />
//                 <Tooltip formatter={(v) => money(v)} />
//                 <Legend />
//                 <Line type="monotone" dataKey="revenue" name="Revenue" strokeWidth={3} dot={false} />
//               </LineChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>

//         <Card
//           title="Product Revenue Share"
//           right={
//             <div className="flex items-center gap-2">
//               {topProduct ? (
//                 <span className="inline-flex items-center gap-2 rounded-xl border border-blue-100 bg-blue-50 px-3 py-2 text-xs font-semibold text-blue-700">
//                   <TrendingUp className="h-4 w-4" /> Top: {topProduct.name}
//                 </span>
//               ) : null}
//               {lowProduct ? (
//                 <span className="inline-flex items-center gap-2 rounded-xl border border-blue-100 bg-white px-3 py-2 text-xs font-semibold text-slate-700">
//                   <TrendingDown className="h-4 w-4" /> Low: {lowProduct.name}
//                 </span>
//               ) : null}
//             </div>
//           }
//         >
//           <div className="h-72">
//             <ResponsiveContainer width="100%" height="100%">
//               <PieChart>
//                 <Tooltip formatter={(v) => money(v)} />
//                 <Legend />
//                 <Pie data={productPie} dataKey="value" nameKey="name" outerRadius={90} innerRadius={45}>
//                   {productPie.map((_, idx) => (
//                     <Cell key={idx} />
//                   ))}
//                 </Pie>
//               </PieChart>
//             </ResponsiveContainer>
//           </div>
//         </Card>
//       </div>

//       {/* State/District analysis + “map tiles” */}
//       <Card
//         title="Geography Analysis"
//         right={
//           <div className="flex gap-2 overflow-x-auto">
//             <Chip active={mode === "state"} onClick={() => setMode("state")}>State Wise</Chip>
//             <Chip active={mode === "district"} onClick={() => setMode("district")}>District Wise</Chip>
//           </div>
//         }
//       >
//         <div className="grid grid-cols-1 gap-6 lg:grid-cols-2">
//           {/* Bars */}
//           <div className="h-80 rounded-2xl border border-blue-100 bg-white p-4">
//             <p className="text-sm font-semibold text-slate-900">
//               {mode === "state" ? "Top States by Revenue" : "Top Districts by Revenue"}
//             </p>
//             <p className="mt-1 text-xs font-semibold text-slate-500">Based on current filters</p>

//             <div className="mt-3 h-64">
//               <ResponsiveContainer width="100%" height="100%">
//                 <BarChart data={mode === "state" ? topStates : topDistricts}>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey={mode === "state" ? "name" : "name"} />
//                   <YAxis />
//                   <Tooltip formatter={(v) => money(v)} />
//                   <Legend />
//                   <Bar dataKey="revenue" name="Revenue" />
//                 </BarChart>
//               </ResponsiveContainer>
//             </div>
//           </div>

//           {/* “Map-like tiles” */}
//           <div className="rounded-2xl border border-blue-100 bg-white p-4">
//             <p className="text-sm font-semibold text-slate-900">
//               {mode === "state" ? "State Heat Tiles (Revenue)" : "District Heat Tiles (Revenue)"}
//             </p>
//             <p className="mt-1 text-xs font-semibold text-slate-500">
//               Click tile to quick-filter (for district: sets State + District)
//             </p>

//             <div className="mt-3 grid grid-cols-2 gap-3 md:grid-cols-3">
//               {(mode === "state" ? byState : byDistrict.slice(0, 9)).map((x) => {
//                 const label = mode === "state" ? x.name : `${x.state} / ${x.name}`;
//                 const active =
//                   mode === "state"
//                     ? state === x.name
//                     : (state === x.state && district === x.name);

//                 return (
//                   <HeatTile
//                     key={mode === "state" ? x.name : x.key}
//                     name={label}
//                     value={x.revenue}
//                     max={maxMapValue}
//                     active={active}
//                     onClick={() => {
//                       if (mode === "state") {
//                         setState(x.name);
//                       } else {
//                         setState(x.state);
//                         setDistrict(x.name);
//                       }
//                     }}
//                   />
//                 );
//               })}
//             </div>
//           </div>
//         </div>
//       </Card>

//       {/* Product comparison table + claimers + credit notes */}
//       <div className="grid grid-cols-1 gap-6 lg:grid-cols-3">
//         <Card title="Product Comparison (Top/Low)">
//           <div className="space-y-3">
//             <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4">
//               <p className="text-xs font-semibold text-slate-500">Top Product</p>
//               <p className="text-sm font-semibold text-slate-900">{topProduct?.name || "—"}</p>
//               <p className="mt-1 text-xs font-semibold text-slate-600">
//                 Revenue: {money(topProduct?.revenue || 0)} • Units: {topProduct?.units || 0}
//               </p>
//             </div>

//             <div className="rounded-2xl border border-blue-100 bg-white p-4">
//               <p className="text-xs font-semibold text-slate-500">Low Product</p>
//               <p className="text-sm font-semibold text-slate-900">{lowProduct?.name || "—"}</p>
//               <p className="mt-1 text-xs font-semibold text-slate-600">
//                 Revenue: {money(lowProduct?.revenue || 0)} • Units: {lowProduct?.units || 0}
//               </p>
//             </div>

//             <div className="mt-2 h-56">
//               <ResponsiveContainer width="100%" height="100%">
//                 <BarChart data={topProducts}>
//                   <CartesianGrid strokeDasharray="3 3" />
//                   <XAxis dataKey="name" />
//                   <YAxis />
//                   <Tooltip formatter={(v) => money(v)} />
//                   <Legend />
//                   <Bar dataKey="revenue" name="Revenue" />
//                 </BarChart>
//               </ResponsiveContainer>
//             </div>
//           </div>
//         </Card>

//         <Card title="Who is mostly sale/claim?">
//           <div className="rounded-2xl border border-blue-100 bg-white p-4">
//             <p className="text-xs font-semibold text-slate-500">Top by Revenue</p>
//             <div className="mt-2 space-y-2">
//               {byCustomer.slice(0, 5).map((c) => (
//                 <div key={c.code} className="flex items-center justify-between rounded-xl border border-blue-100 bg-blue-50 p-3">
//                   <div>
//                     <p className="text-sm font-semibold text-slate-900">{c.name}</p>
//                     <p className="text-xs font-semibold text-slate-600">Code: {c.code}</p>
//                   </div>
//                   <p className="text-sm font-semibold text-blue-700">{money(c.revenue)}</p>
//                 </div>
//               ))}
//             </div>
//           </div>

//           <div className="mt-4 rounded-2xl border border-blue-100 bg-white p-4">
//             <p className="text-xs font-semibold text-slate-500">Top by Claims</p>
//             <div className="mt-2 space-y-2">
//               {mostClaims.map((c) => (
//                 <div key={c.code} className="flex items-center justify-between rounded-xl border border-blue-100 bg-white p-3">
//                   <div>
//                     <p className="text-sm font-semibold text-slate-900">{c.name}</p>
//                     <p className="text-xs font-semibold text-slate-600">Code: {c.code}</p>
//                   </div>
//                   <p className="text-sm font-semibold text-slate-900">{c.claims}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </Card>

//         <Card title="Credit Notes Ratio & Leaders">
//           <div className="rounded-2xl border border-blue-100 bg-blue-50 p-4">
//             <p className="text-xs font-semibold text-slate-500">Credit Note Ratio</p>
//             <p className="text-lg font-semibold text-slate-900">{pct(kpis.creditRatio)}</p>
//             <p className="mt-1 text-xs font-semibold text-slate-600">
//               CN: {money(kpis.creditNotes)} / Revenue: {money(kpis.revenue)}
//             </p>
//           </div>

//           <div className="mt-4 rounded-2xl border border-blue-100 bg-white p-4">
//             <p className="text-xs font-semibold text-slate-500">Who raises most Credit Notes</p>
//             <div className="mt-2 space-y-2">
//               {mostCreditNotes.map((c) => (
//                 <div key={c.code} className="flex items-center justify-between rounded-xl border border-blue-100 bg-white p-3">
//                   <div>
//                     <p className="text-sm font-semibold text-slate-900">{c.name}</p>
//                     <p className="text-xs font-semibold text-slate-600">Code: {c.code}</p>
//                   </div>
//                   <p className="text-sm font-semibold text-slate-900">{money(c.creditNotes)}</p>
//                 </div>
//               ))}
//             </div>
//           </div>
//         </Card>
//       </div>

//       {/* Quick table (state/district) */}
//       <Card title={mode === "state" ? "State Wise Table" : "District Wise Table"}>
//         <div className="overflow-x-auto">
//           <table className="w-full text-sm">
//             <thead>
//               <tr className="border-b text-left text-slate-700">
//                 <th className="py-3">{mode === "state" ? "State" : "District"}</th>
//                 {mode === "district" ? <th>State</th> : null}
//                 <th>Revenue</th>
//                 <th>Units</th>
//                 <th>Claims</th>
//                 <th>Credit Notes</th>
//                 <th>CN Ratio</th>
//               </tr>
//             </thead>
//             <tbody>
//               {(mode === "state" ? byState : byDistrict).slice(0, 12).map((x) => (
//                 <tr key={mode === "state" ? x.name : x.key} className="border-b hover:bg-slate-50">
//                   <td className="py-3 font-semibold text-slate-900">{x.name}</td>
//                   {mode === "district" ? <td className="font-semibold text-slate-700">{x.state}</td> : null}
//                   <td className="font-semibold">{money(x.revenue)}</td>
//                   <td className="font-semibold text-slate-700">{x.units}</td>
//                   <td className="font-semibold text-slate-700">{x.claims}</td>
//                   <td className="font-semibold">{money(x.creditNotes)}</td>
//                   <td className="font-semibold text-blue-700">
//                     {x.revenue > 0 ? pct(x.creditNotes / x.revenue) : "0.0%"}
//                   </td>
//                 </tr>
//               ))}
//             </tbody>
//           </table>
//         </div>
//       </Card>
//     </div>
//   );
// }


